<template>
  <div id="app">
    <div class="links">
      <a href="#" :class="selected === charts.ZING && 'selected'" @click="selected = charts.ZING">ZingChart</a>
      <a href="#" :class="selected === charts.FUSION && 'selected'" @click="selected = charts.FUSION">FusionCharts</a>
      <a href="#" :class="selected === charts.APEX && 'selected'" @click="selected = charts.APEX">ApexChart</a>
      <a href="#" :class="selected === charts.AM && 'selected'" @click="selected = charts.AM">AmChart</a>
      <a href="#" :class="selected === charts.ANY && 'selected'" @click="selected = charts.ANY">AnyChart</a>
    </div>

    <ZingChart v-if="selected === charts.ZING" />
    <FusionCharts v-if="selected === charts.FUSION" />
    <ApexChart v-if="selected === charts.APEX" />
    <AmChart v-if="selected === charts.AM" />
    <AnyChart v-if="selected === charts.ANY" />
  </div>
</template>

<script>
import ZingChart from '@/components/ZingChart';
import FusionCharts from '@/components/FusionCharts';
import ApexChart from '@/components/ApexChart';
import AmChart from '@/components/AmChart';
import AnyChart from '@/components/AnyChart';

const charts = {
  ZING: 'ZING',
  FUSION: 'FUSION',
  APEX: 'APEX',
  AM: 'AM',
  ANY: 'ANY'
};

export default {
  components: {
    AnyChart,
    AmChart,
    ApexChart,
    ZingChart,
    FusionCharts
  },

  data() {
    return {
      charts,
      selected: charts.ZING
    };
  }
}
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .links {
    margin-bottom: 15px;
    text-align: center;
  }

  .links a {
    color: #333;
    margin-left: 10px;
    margin-right: 10px;
    border-bottom: 1px solid transparent;
    text-decoration: none;
  }

  .links a.selected {
    border-color: #666;
  }
</style>
